// assets
import { IconDashboard, IconHistory, IconFileAnalytics, IconChartBar, IconFile, IconFileInvoice, IconMoneybag, IconTransfer, IconHistoryOff, IconExchange, IconUsersGroup } from '@tabler/icons-react';

// constant
const icons = { IconUsersGroup, IconHistory, IconDashboard, IconFileAnalytics, IconChartBar, IconFileInvoice, IconMoneybag, IconFile, IconTransfer, IconHistoryOff, IconExchange };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const accountingDashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    roles: ['super_admin', 'system_admin', 'department_head'],
    permissions: ['dashboard.read'],
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/accounting/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'Invoices',
            title: 'Invoices',
            type: 'item',
            url: '/accounting/invoices',
            icon: icons.IconFileInvoice,
            breadcrumbs: false,
            permissions: ['invoices.read']
        },
        {
            id: 'certificates',
            title: 'Certificates',
            type: 'item',
            url: '/accounting/certificates',
            icon: icons.IconFile,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'payments',
            title: 'Confirm Payments',
            type: 'item',
            url: '/accounting/payments',
            icon: icons.IconMoneybag,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'history',
            title: 'Payments History',
            type: 'item',
            url: '/accounting/payments-history',
            icon: icons.IconHistoryOff,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'expenditure',
            title: 'Expenditure',
            type: 'item',
            url: '/accounting/expenditures',
            icon: icons.IconExchange,
            breadcrumbs: false,
            permissions: ['certificates.read']
        },
        {
            id: 'transfers',
            title: 'Internal Transfers',
            type: 'item',
            url: '/accounting/transfers',
            icon: icons.IconTransfer,
            breadcrumbs: false,
            permissions: ['fund_transfers.read']
        },
        {
            id: 'performance',
            title: 'Team Performance',
            type: 'item',
            url: '/accounting/team',
            target: false,
            icon: icons.IconUsersGroup,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        },
        {
            id: 'reports',
            title: 'Analytic Reports',
            type: 'item',
            url: '/accounting/reports',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.IconHistory,
            url: '/accounting/audit-logs',
            target: false,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        }
    ]
};

export default accountingDashboard;
